import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import '../WorkFlow.css'
import { lang } from '../../generales/traduction';
import Modal from 'react-modal';
import ModalInfoDemo from "./ModalInfoDemo";
// import Search from '../../../generales/Search';
// import Paginador from '../../../generales/Paginador';
import WorkflowApp from './WorkflowApp';
import { he } from 'date-fns/locale';
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const ModalCreateWorkFlow = ({ server, page, setPage, buscar_cis, languaje, mode, hosts, handleShowPopup, closCreateCisModal }) => {
  const [poolRows, setPoolRows] = useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected, setHostSelected] = useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [disabled, setDisabled] = useState(true)
  const [disabledPage1, setDisabledPage1] = useState(true)
  const [loading, setLoading] = useState(false)
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {

    setDeleteUserModalOpen(false);
  }
  var dataList = searchTerm === "" ? hosts : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      setPoolRows(hosts.map(item => item.hostid))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value); setPageActual(1);
  };
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.hostid);
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento.hostid];
      }
    });
    setHostSelected((prevRows) => {
      // Busca si el hostid ya existe en el array de objetos
      const exists = prevRows.some(item => item.hostid === elemento.hostid);

      // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(item => item.hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento];
      }
    });
  };
  const [dataWorkFlow, setDataWorkFlow] = useState({
    name: "",
    description: "",
    hostid: null,
    groupid: null,
    metric_id: 0,
    trigger_id: 0,
    workflow_eventid: 0,
    interested_user_group_ids: [],
    telegram_groups: [],
    event_auto_close: false,
    ticket_auto: false
  })
  const Registrar = () => {
    setLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/workflow/', {
          method: 'POST',
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(dataWorkFlow),
        });
        if (response.ok) {

          const data1 = await response.json();
          setLoading(false)
          // Manejo de la respuesta
          // setData(data1)

          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['regGenCorr'])), '', true)
          // console.log(data1);
          closCreateCisModal()
          setPage(true)
          buscar_cis()


        } else {
          const data1 = await response.json();
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regNoGenCorr']), data1.detail, false)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {


        setLoading(false)

        closCreateCisModal()
        //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)

        console.error(error);
      }
    };

    fetchDataPost();
  }
  useEffect(() => {
    if (dataWorkFlow.name == "" || dataWorkFlow.description == "") {
      setDisabledPage1(true)
    } else {
      setDisabledPage1(false)
    }

    if ((dataWorkFlow.hostid == null && dataWorkFlow.groupid == null) || dataWorkFlow.metric_id == 0 || dataWorkFlow.trigger_id == 0 || dataWorkFlow.workflow_eventid == 0
      || (dataWorkFlow.interested_user_group_ids.length == 0 && dataWorkFlow.telegram_groups.length == 0)) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [dataWorkFlow])
  const handleChange = (e) => {
    const { name, value } = e.target

    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        [name]: value
      }

    })
  }
  const reqField = () => {
    return (
      <p className='reqField-gs'>
        *
      </p>
    )
  }
  const { name, description } = dataWorkFlow;

  const btnBase = {
    height: 36,
    padding: '0 18px',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    transition: 'all 0.15s ease',
    letterSpacing: '0.01em',
    border: 'none',
  };

  const btnPrimaryStyle = {
    ...btnBase,
    background: '#1a56db',
    color: '#ffffff',
    boxShadow: '0 1px 2px rgba(15,45,94,0.1)',
  };

  const btnOutlineStyle = {
    ...btnBase,
    background: '#ffffff',
    color: '#1a56db',
    border: '1px solid #1a56db',
  };

  const btnDisabledStyle = {
    ...btnBase,
    background: '#ffffff',
    color: '#94a3b8',
    border: '1px solid #e2e8f0',
    cursor: 'not-allowed',
    boxShadow: 'none',
  };

  const [hoverBtn, setHoverBtn] = useState(null);

  const modalContainerStyle = {
    position: 'relative',
    width: '100%',
    // maxWidth: '95vw',
    // maxHeight: '92vh',
    background: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
  };

  const headerStyle = {
    background: '#0f2d5e',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  };

  const footerStyle = {
    padding: '14px 24px',
    borderTop: '1px solid #e2e8f0',
    background: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexShrink: 0,
  };

  const canSave = !disabled;

  return (
    <>
      <div className="modal-GS-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(0,0,0,0.5)' }}>
        <div style={modalContainerStyle}>
          {/* Header Global */}
          <div style={headerStyle}>
            <div>
              <div style={{ color: '#ffffff', fontSize: 16, fontWeight: 600 }}>
                {lang[languaje]['crear'].toUpperCase() + " " + lang[languaje]['workflow'].toUpperCase()}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                Diseña el flujo automatizado de respuesta
              </div>
            </div>
            <button
              onClick={closCreateCisModal}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                borderRadius: '50%',
                width: 32,
                height: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#ffffff',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Content Area */}
          <div style={{ flex: 1, overflowY: 'auto', padding: page ? '40px' : '0' }}>
            {page ? (
              <div className="form-GS-box" style={{ gap: '20px', maxWidth: '600px', margin: '0 auto' }}>
                <div className="user-box-GS">
                  <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(name == "") ? reqField() : ''}</label>
                  <input required name="name" type="text" value={name} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }} />
                </div>
                <div className="user-box-GS">
                  <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['descripcion'])}{(description == "") ? reqField() : ''}</label>
                  <input required name="description" type="text" value={description} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0' }} />
                </div>
              </div>
            ) : (
              <div style={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
                <WorkflowApp
                  dataWorkFlow={dataWorkFlow}
                  setDataWorkFlow={setDataWorkFlow}
                  server={server}
                  languaje={languaje}
                  mode={mode}
                  hosts={hosts}
                />
              </div>
            )}
          </div>

          {/* Footer Global */}
          <div style={footerStyle}>
            <div style={{ fontSize: 12, color: '#64748b' }}>
              {page
                ? 'Ingresa los datos básicos para comenzar el flujo'
                : 'Diseña tu flujo arrastrando los recursos al canvas'
              }
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              {page ? (
                <>
                  <button
                    style={{
                      ...btnOutlineStyle,
                      background: hoverBtn === 'cancel' ? '#e8f0fe' : '#ffffff',
                    }}
                    onClick={closCreateCisModal}
                    onMouseEnter={() => setHoverBtn('cancel')}
                    onMouseLeave={() => setHoverBtn(null)}
                  >
                    {capitalizeFirstLetter(lang[languaje]['cancelar'])}
                  </button>
                  <button
                    style={{
                      ...(disabledPage1 ? btnDisabledStyle : btnPrimaryStyle),
                      background: !disabledPage1 && hoverBtn === 'next' ? '#1e40af' : (disabledPage1 ? '#ffffff' : '#1a56db'),
                      transform: !disabledPage1 && hoverBtn === 'next' ? 'translateY(-1px)' : 'none',
                      boxShadow: !disabledPage1 && hoverBtn === 'next' ? '0 4px 8px rgba(15,45,94,0.18)' : (disabledPage1 ? 'none' : '0 1px 2px rgba(15,45,94,0.1)'),
                    }}
                    disabled={disabledPage1}
                    onClick={() => setPage(false)}
                    onMouseEnter={() => !disabledPage1 && setHoverBtn('next')}
                    onMouseLeave={() => setHoverBtn(null)}
                  >
                    {capitalizeFirstLetter(lang[languaje]['siguiente'])}
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{
                      ...btnOutlineStyle,
                      background: hoverBtn === 'back' ? '#e8f0fe' : '#ffffff',
                    }}
                    onClick={() => setPage(true)}
                    onMouseEnter={() => setHoverBtn('back')}
                    onMouseLeave={() => setHoverBtn(null)}
                  >
                    {capitalizeFirstLetter(lang[languaje]['regresar'])}
                  </button>
                  <button
                    style={{
                      ...btnOutlineStyle,
                      background: hoverBtn === 'cancel2' ? '#e8f0fe' : '#ffffff',
                    }}
                    onClick={closCreateCisModal}
                    onMouseEnter={() => setHoverBtn('cancel2')}
                    onMouseLeave={() => setHoverBtn(null)}
                  >
                    {capitalizeFirstLetter(lang[languaje]['cancelar'])}
                  </button>
                  <button
                    style={{
                      ...(canSave ? btnPrimaryStyle : btnDisabledStyle),
                      background: canSave && hoverBtn === 'save' ? '#1e40af' : (canSave ? '#1a56db' : '#ffffff'),
                      transform: canSave && hoverBtn === 'save' ? 'translateY(-1px)' : 'none',
                      boxShadow: canSave && hoverBtn === 'save' ? '0 4px 8px rgba(15,45,94,0.18)' : (canSave ? '0 1px 2px rgba(15,45,94,0.1)' : 'none'),
                    }}
                    disabled={!canSave}
                    onClick={openDeleteUserModal}
                    onMouseEnter={() => canSave && setHoverBtn('save')}
                    onMouseLeave={() => setHoverBtn(null)}
                  >
                    {capitalizeFirstLetter(lang[languaje]['guardar'])}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalInfoDemo closCreateCisModal={closCreateCisModal} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setLoading={setLoading} closDeleteUserModal={closDeleteUserModal}></ModalInfoDemo>
      </Modal>
    </>
  )
}

export default ModalCreateWorkFlow